import FColumnCellMDP from '../FColumnCellMDP';
export default class FInfoHighlightMDP implements FColumnCellMDP {
    componentName: string = "FInfoHighlight";
    icon?: string
    constructor(props: {icon?: string}) {
        this.icon = props.icon;
    }
    getMetaData(): object {
        return {
            componentName: this.componentName,
            props: {
                icon:this.icon
            }
        }
    }

}